/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CreateAgreementApiData {
  agreementType?: string;
  tenantId?: string;
  tenantName?: string;
  propertyAddress?: string;
  unitNumber?: string;
  leaseStartDate?: string;
  leaseEndDate?: string;
  leaseDuration?: string;
  rentAmount?: string;
  paymentFrequency?: string;
  paymentMethod?: string;
  dueDate?: string;
  securityDeposit?: string;
  lateFeeAmount?: string;
  gracePeriod?: string;
  utilitiesIncluded?: string;
  specialTerms?: string;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  emergencyContactRelationship?: string;
  isEditAgreementDetails?: boolean;
}

interface IAgreements {
  createAgreementApiData: CreateAgreementApiData;
  isShowAgreementsModal: boolean;
  activeAgreementsModal:
    | 'createAgreementModal'
    | 'createAgreementSuccessModal'
    | 'editAgreementModal'
    | 'editAgreementSuccessModal'
    | 'signLeaseAgreementModal'
    | 'signLeaseSuccessModal'
    | '';
  refetchAgreements: boolean;
}

const initialState: IAgreements = {
  createAgreementApiData: {},
  isShowAgreementsModal: false,
  activeAgreementsModal: '',
  refetchAgreements: false
};

const agreementsSlice = createSlice({
  name: 'agreements',
  initialState,
  reducers: {
    setIsShowAgreementsModal: (state: IAgreements, action: PayloadAction<boolean>) => {
      state.isShowAgreementsModal = action.payload;
    },
    setActiveAgreementsModal: (
      state: IAgreements,
      action: PayloadAction<
        | 'createAgreementModal'
        | 'createAgreementSuccessModal'
        | 'editAgreementModal'
        | 'editAgreementSuccessModal'
        | 'signLeaseAgreementModal'
        | 'signLeaseSuccessModal'
        | ''
      >
    ) => {
      state.activeAgreementsModal = action.payload;
    },
    setCreateAgreementApiData: (
      state: IAgreements,
      action: PayloadAction<CreateAgreementApiData>
    ) => {
      state.createAgreementApiData = action.payload;
    },
    setRefetchAgreements: (state: IAgreements, action: PayloadAction<boolean>) => {
      state.refetchAgreements = action.payload;
    }
  }
});

export const {
  setIsShowAgreementsModal,
  setActiveAgreementsModal,
  setCreateAgreementApiData,
  setRefetchAgreements
} = agreementsSlice.actions;

export default agreementsSlice.reducer;
